import { createSelector } from '@ngrx/store'
import { getState, State } from '../state'

export const getSelectedSettingsTechnique = createSelector(
  getState,
  (state: State) => state.compoundParams.selectedSettingsTechnique,
)
